<template>
  <div class="min-h-screen">

    <div class="header">

      <div class="w-full h-full absolute top-0 left-0 bg-webapps"></div>

      <svg height="0" width="0"  xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="svgPath" clipPathUnits="objectBoundingBox">
            <path d="M1,0.8c0,0-0.173988,0.2-0.5,0.2S0,0.8,0,0.8V-1h1V0.8z"/>
            <!--<path d="M1,0.241607c0,0-0.173988,0.068303-0.500023,0.06830S0,0.24161,0,0.24161V-1h1V0.241607z"/>-->
          </clipPath>
        </defs>

      </svg>

      <section class="page-content">
        <div class="tab flex justify-between mb-12">
          <div><h3 class="uppercase text-button lg:text-2xl font-bold">Web app</h3></div>
          <div class="flex">
            <router-link tab="span" :to="{name: 'Websites'}" class="inline mr-12 cursor-pointer"><h3 class="uppercase text-button lg:text-2xl hover:text-black font-bold text-black text-opacity-50">Siti web</h3></router-link>
            <router-link tag="span" :to="{name: 'MobileApps'}" class="inline  cursor-pointer"><h3 class="uppercase text-button lg:text-2xl hover:text-black font-bold text-black text-opacity-50">App mobile</h3></router-link>
          </div>
        </div>

        <h1 class="text-xl lg:text-title font-bold">Realizzazione web app, spa e pwa</h1>
        <p>Ferrara è la città dove lavoro ma seguo clienti in tutto il nord Italia.</p>
      </section>

    </div>



    <section class="page-content">
      <p><strong>Sviluppare una web app è il modo migliore per dare vita a soluzioni efficienti in maniera funzionale ed affidabile.
        Queste possono facilmente integrarsi con i software aziendali in uso per integrarne e estenderne le funzionalità.</strong>
      Esse ti permettono di rendere disponibile online le informazioni, i tool e i dati necessari sia agli utenti interni sia ai propri clienti.
      Tutto questo per fornirti un grande vantaggio competitivo.</p>

      <p><strong>La grande versatilità delle web app le rende delle valide alternative alle tradizionali app mobile, grazie alla
      capacità di essere eseguite su tutti i dispositivi in grado di accedere alla rete internet.</strong> Avere un'unica soluzione per
        più dispositivi comporta un notevole risparmio di risorse, sia in fase di sviluppo che di manutenzione non dovendo gestire
      le versioni native di ogni piattaforma.</p>

    </section>



    <!--call to action-->
    <call-to-action page="webApp"></call-to-action>

    <section class="page-content">
      <h2 class="text-xl lg:text-title font-bold mb-12">Web app, spa e pwa... what?</h2>

      <p>Potresti non aver mai sentito parlare di web app, spa (single page application) e pwa (progressive web app).</p>

      <p><strong>
        Sicuramente però hai già usato almeno una web app navignado in internet.
      </strong></p>

      <p>Questo perchè molti dei siti che usi più di frequente, basta a pensare a social come <strong>Facebook</strong> o anche a <strong>Gmail</strong>,
        non sono altro che web app, cioè <strong>applicativi o software</strong> che “girano”, cioè <strong>funzionano sul web.</strong></p>

      <p>Generalmente se sei un sito dove ti puoi registrare e in seguito sei in grado di “fare qualcosa”, tipo
        modificare documenti, gestire la tua posta elettronica, gestire la tua contabilità, eccetera... sicuramente stai
        uisando una web app.</p>

      <p><strong>Per SPA, cioè Single Page Application</strong> non si intende altro che una web app in cui le pagine vengono caricate
        dinamicamente senza dover ricaricare il browser.</p>

      <p><strong>Questo tipo di app risulta molto veloce e piacevole da navigare</strong> pagine quando si cambia pagina
        il browser non deve ricaricare tutte le risorse che servono per far funzionare l’app, ma soltanto i nuovi dati
        che devono essere visualizzati.</p>

      <p><strong>Le PWA, cioè Progressive Web App</strong> sono una variante delle <strong>SPA</strong> in cui quest’ultima
        viene incapsulata in una sorta di app mobile, potendola così installare sul proprio smartphone ed usarla come una
        normale app.</p>

      <p><strong>Una web app potrebbe essere qualsiasi cosa, e potrebbe aiutarti a fare qualsiasi cosa tu voglia.</strong></p>

    </section>

    <!--last reviews-->
    <last-cat-reviews title="Per loro ho realizzato una web app." :limit="2" cat="Web app"></last-cat-reviews>

    <!--tell me-->
    <tell-me page="webApp"></tell-me>


    <!--contact form-->
    <contact-form page="webapps"></contact-form>

    <!--skills-->
    <section class="page-content">

      <div>
        <h3 class="text-xl lg:text-title font-bold mb-10">Competenze e strumenti</h3>
        <p>Se non capisci cosa sono queste scritte allora ho una buona notizia per te. <strong>Sei completamente sano!</strong></p>
      </div>
      <skills></skills>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
  import TellMe from '../components/TellMe'
  import ContactForm from '../components/ContactForm'
  import Skills from '../components/Skills'
  import CallToAction from '../components/CallToAction'
  import LastCatReviews from '../components/LastCatReviews'
  import Footer from '../components/Footer'
  import { routerMixin } from "../mixins/routerMixin";
  import { analyticsMixin } from "../mixins/analyticsMixin";
  import { vuemetaMixin } from "../mixins/vuemetaMixin";

  export default {
    name: "Webapps",
    mixins: [routerMixin, analyticsMixin, vuemetaMixin],
    metaInfo() {
      return {
        title: this.meta.title,
        titleTemplate: ' %s | Gianluca Lomarco',
        meta: [
          { vmid: 'description', name: 'description', content: this.meta.description },
          { property: 'og:title', content: 'Gianluca Lomarco Web Designer e Sviluppatore Web'},
          { property: 'og:description', content: this.meta.description},
          { property: 'og:image', content: this.siteUrl+'/img/web-app.png'},
          { property: 'og:url', content: this.siteUrl + '/realizzazione-web-app' },
          { property: 'twitter:card', content: 'summary_large_image'},
          { property: 'og:site_name', content: this.siteName },
          { property: 'twitter:image:alt', content: 'Immagine di copertita di Gianluca Lomarco'},
        ],
        link: [
          { rel: 'canonical', href: this.siteUrl + '/realizzazione-web-app', id: 'canonical'}
        ]
      }
    },
    data() {
      return {
        meta: {
          title: 'Realizzazione Web App a Ferrara',
          description: 'Realizzo Web App personalizzate con tutte le funzionalità di cui hai bisogno. Scopri che cosa possiamo realizzare insieme.'
        }
      }
    },
    components: {
      ContactForm,
      Footer,
      Skills,
      TellMe,
      CallToAction,
      LastCatReviews
    },
  }
</script>

<style scoped>

  .bg-webapps {
    background-image: url("/img/sfondo-web-app-home.svg");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
  }


  .column-count-3 {
    column-count: 3;
  }

  .column-count-3 li {
    line-height: 45px;
  }

  .header {
    position: relative;
    height: 650px;
    box-sizing: border-box;
    padding-top: 160px;
    clip-path: url(#svgPath);
    -webkit-clip-path: url(#svgPath);
    /*background-color: purple;*/
  }

  @media only screen and (max-width: 768px) {
    .header {
      height: auto;
      min-height: 350px;
      padding-top: 80px;
    }
  }
</style>